export const deliveryMapColorConfig = {
  'BR': ['#fea32f', '#31b77e', '#3881b8', '#f3bc38', '#db2a36'],
  'MX': ['#ff7a45', '#31b77e', '#3881b8', '#f3bc38', '#db2a36'],
  'CL': ['#ff7a45', '#31b77e', '#3881b8', '#f3bc38', '#db2a36'],
  'CR': ['#ff7a45', '#31b77e', '#3881b8', '#f3bc38', '#db2a36'],
  'PE': ['#ff7a45', '#31b77e', '#3881b8', '#f3bc38', '#db2a36'],
  'CO': ['#ff7a45', '#31b77e', '#3881b8', '#f3bc38', '#db2a36'],
  'DO': ['#ff7a45', '#31b77e', '#3881b8', '#f3bc38', '#db2a36'],
  'JP': ['#ff7a45', '#31b77e', '#3881b8', '#f3bc38', '#db2a36']
}
